import React from 'react';
import { useEmmaContext } from '../../../contexts/EmmaContext';

/**
 * Story 24.35: Compact View Component
 * Minimal Emma input bar for desktop/tablet
 */
interface CompactViewProps {
  onExpand?: () => void;
}

export const CompactView: React.FC<CompactViewProps> = ({ onExpand }) => {
  const { updatePersistentInterface } = useEmmaContext();

  const handleFocus = () => {
    // Auto-expand on focus
    if (onExpand) {
      onExpand();
    }
    // Also persist to context for page reload
    updatePersistentInterface?.({ viewState: 'expanded' });
  };

  return (
    <div className="emma-compact-view">
      <div className="compact-input">
        <input
          type="text"
          placeholder="Ask Emma anything..."
          onFocus={handleFocus}
          aria-label="Ask Emma"
        />
      </div>
    </div>
  );
};
